import React, { useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import langData from "../../locales/langData.json";
import "../../assets/css/contactform.css";

function ContactForm({ language }) {
  const t = langData[language].contactform;
  const v = langData[language].validation;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // store ONLY error keys, not text
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "required";
    if (!formData.phone.trim()) newErrors.phone = "required";
    if (!formData.message.trim()) newErrors.message = "required";

    if (!formData.email.trim()) {
      newErrors.email = "required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "email";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    fetch(
      "https://script.google.com/macros/s/AKfycbwdSOqdD-RZZN20qA13-_UAXHOWmK_fmMjYWb9OFWvamCIlNzKRd9eo3-qtcCAQfNv-QQ/exec",
      {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );
  };

  return (
    <Container className={`contact-form ${language === "ar" ? "text-end" : ""}`}>
      <Form dir={language === "ar" ? "rtl" : "ltr"} onSubmit={handleSubmit}>

        {/* Name */}
        <Form.Group className="mb-1">
          <Form.Label>{t.fullName}</Form.Label>
          <Form.Control
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="contact-input"
            placeholder={t.placeholderName}
          />
          {errors.name && (
            <small className="text-danger">{v[errors.name]}</small>
          )}
        </Form.Group>

        {/* Email */}
        <Form.Group className="mb-1">
          <Form.Label>{t.email}</Form.Label>
          <Form.Control
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="contact-input"
            placeholder={t.placeholderEmail}
          />
          {errors.email && (
            <small className="text-danger">{v[errors.email]}</small>
          )}
        </Form.Group>

        {/* Phone */}
        <Form.Group className="mb-1">
          <Form.Label>{t.phone}</Form.Label>
          <Form.Control
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="contact-input"
            placeholder={t.placeholderPhone}
          />
          {errors.phone && (
            <small className="text-danger">{v[errors.phone]}</small>
          )}
        </Form.Group>

        {/* Message */}
        <Form.Group className="mb-3">
          <Form.Label>{t.message}</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="contact-input"
            placeholder={t.placeholderMessage}
          />
          {errors.message && (
            <small className="text-danger">{v[errors.message]}</small>
          )}
        </Form.Group>

        <Button type="submit" className="w-100 form-btn">
          {t.submit}
        </Button>
      </Form>
    </Container>
  );
}

export default ContactForm;
